module.exports = __webpack_public_path__ + "static/media/insurance-logo.46087c65.svg";